import { Card } from '../ui/card'
import { Badge } from '../ui/badge'
import { StandardPartsInformation } from 'store/types'

export const EmissionHeader = ({
  general,
  technical,
  identification,
}: StandardPartsInformation) => {
  return (
    <Card className="p-6">
      <div className="flex flex-col md:flex-row gap-6">
        <div className="flex-shrink-0">
          <img
            src={general.imgUrl}
            alt={general.variantName}
            className="w-48 h-48 object-contain bg-muted rounded-lg"
          />
        </div>
        <div className="flex-1 space-y-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Badge variant="secondary">{general.variant}</Badge>
              <Badge variant="outline">{identification.group}</Badge>
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-2">
              {general.variantName}
            </h1>
            <p className="text-muted-foreground">{identification.fullName}</p>
          </div>
          <div className="flex flex-wrap gap-4 text-sm">
            <div>
              <span className="text-muted-foreground">Class:</span>
              <span className="ml-2 font-medium">{identification.class}</span>
            </div>
            <div>
              <span className="text-muted-foreground">Weight:</span>
              <span className="ml-2 font-medium">{technical.weight} kg</span>
            </div>
          </div>
          <p className="text-muted-foreground">Reference unit: kg</p>
        </div>
      </div>
    </Card>
  )
}
